@if (!isLastDashboardClosed) {
    @if (workspace) {
        @if (dashboard) {
            <ddv-dashboard-header-name
                [dashboard]="dashboard"
                [sharing]="sharing"
                [inPresentationMode]="inPresentationMode"
                [isDirty]="dirtyFlagService.isDirty"
                [userEntitlements]="userEntitlements"
                [memberOf]="memberOf"
                (editAction)="relayEditAction($event)"
                (dashboardSwitch)="dashboardSwitch.emit($event)"
            >
            </ddv-dashboard-header-name>
        }

        <ddv-dashboard-filters
            [clientCode]="clientCode ?? ''"
            [id]="dashboard?.id ?? 0"
            [inMultiEnvironment]="isMultiClient"
            [userPreferences]="userPreferences"
            [queryParams]="dashboardPrefs"
            [funds]="funds"
            [clients]="clients"
            [fuzzyDates]="ccFuzzyDates ?? []"
            [namedQueries]="namedQueries"
            [viewMode]="viewMode"
            (applyFunds)="onApplySelectedFunds($event)"
            (applyClients)="onApplySelectedClients($event)"
            (applyDateFilter)="onApplyDateChanges($event)"
            (applyAdditionalFilters)="onApplyAdditionalFilters($event)"
        >
            <ddv-refresh-restore
                [showRestore]="true"
                (refresh)="onRefreshCurrentDashboard()"
                (restore)="onRestoreCurrentDashboard()"
            >
            </ddv-refresh-restore>
        </ddv-dashboard-filters>

        @if (canExport && useNewExports) {
            <ddv-dashboard-export
                [clientCode]="clientCode"
                [dashboard]="dashboard"
                [widgets]="widgets"
                [hasCrosstalkData]="hasCrosstalkData"
            >
            </ddv-dashboard-export>
        }

        <div class="export-icon-list">
            <app-hs-dashboard-header-menu
                [currentDashboard]="workspace"
                [inPresentationMode]="inPresentationMode"
                [isMultiClient]="isMultiClient"
                [userPreferences]="userPreferences"
                [entitlements]="userEntitlements"
                [includeExports]="!useNewExports"
                (restoreClicked)="onRestoreCurrentDashboard()"
                (refreshClicked)="onRefreshCurrentDashboard()"
                (queryParamApply)="onUpdateDashboardQueryParams($event)">
            </app-hs-dashboard-header-menu>
        </div>

        <ddv-user-preferences
            [clientCode]="clientCode"
            [isMultiClient]="isMultiClient"
            [user]="user"
            [userEntitlements]="userEntitlements"
            [userPreferences]="userPreferences"
            [funds]="funds"
            [clients]="clients"
            [fuzzyDates]="ccFuzzyDates"
            (userPreferencesChange)="userPreferencesChange.emit($event)"
        >
        </ddv-user-preferences>
    }
}
